module.exports = __webpack_public_path__ + "static/img/tablet-header-logo.7eda9d6c.svg";